module.exports = __webpack_public_path__ + "img/tabarok_logo.cdd311d9.png";